export const entityHeaders = (t: ({}) => string) => {
  return [
    { value: 'name', text: t({ s: 'entitiesTab.headers.name', component: 'Businesses' }), width: 100 },
    { value: 'short_name', text: t({ s: 'entitiesTab.headers.frameNumber', component: 'Businesses' }), width: 100, sortable: false },
    { value: 'imei', text: t({ s: 'entitiesTab.headers.deviceImei', component: 'Businesses' }), width: 100, sortable: false },
    { value: 'vendor', text: t({ s: 'entitiesTab.headers.business', component: 'Businesses' }), width: 100, sortable: false },
    { value: 'user_name', text: t({ s: 'entitiesTab.headers.userName', component: 'Businesses' }), width: 100, sortable: false },
    { value: 'subscription', text: t({ s: 'entitiesTab.headers.subscription', component: 'Businesses' }), width: 100, sortable: false },
    { value: 'last_seen_at', text: t({ s: 'entitiesTab.headers.lastSeen', component: 'Businesses' }), width: 130, sortable: false },
    { value: 'created_at', text: t({ s: 'entitiesTab.headers.createdAt', component: 'Businesses' }), width: 130 },
    { value: 'actions', text: t({ s: 'entitiesTab.headers.linkTo', component: 'Businesses' }), sortable: false, width: 100 }
  ]
}

export const userHeaders = (t: ({}) => string) => {
  const headers = [
    { text: 'name', value: 'name', width: 120 },
    { text: 'email', value: 'email', width: 120 },
    { text: 'role', value: 'role', width: 100 },
    { text: 'business', value: 'sub_vendor_name', width: 120 },
    { text: 'lastSeen', value: 'last_seen_at', width: 140 },
    { text: 'actions', value: 'actions', width: 100 }
  ]
  return headers.map(({ text, value, width }) => ({
    text: t({ s: `usersTab.headers.${text}`, component: 'Businesses' }),
    value,
    width
  }))
}

export const deviceHeaders = (t: ({}) => string) => {
  const headers = [
    { header: 'imei', value: 'imei', sortable: false, width: 100 },
    { header: 'entityName', value: 'entity_name', sortable: false, width: 100 },
    { header: 'business', value: 'business_name', sortable: false, width: 100 },
    { header: 'lastSeen', value: 'last_seen_at', sortable: false, width: 100 }]

  return headers.map(h => ({
    ...h,
    text: t({ s: `devicesTab.headers.${h.header}`, component: 'Businesses' }),
    value: h.value
  }))
}
